import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = { class: "field has-addons" }
const _hoisted_4 = { class: "control is-expanded" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "control" }
const _hoisted_9 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "control" }
const _hoisted_12 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "control" }
const _hoisted_15 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_16 = {
  key: 1,
  class: "help is-danger"
}

import { required, maxLength, numeric } from '@vuelidate/validators';
import { config } from '@/config/config';
import { btApi } from './services/btApi';
import Toast from '@/shared/services/toast';
import { BTInstalledApp, InstallBTRequest } from './models';
import { useClipboard } from '@vueuse/core';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, onBeforeMount, ref } from 'vue';
import useVuelidate from '@vuelidate/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'btsmsConfig',
  emits: ["loaded", "configSaved"],
  setup(__props, { emit: __emit }) {

const webhookUrl: string = `${config().btHost}/v1/webhook`;

const emit = __emit;

const { copy } = useClipboard();
const router = useRouter();
const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const currentApp = computed(() => store.getters.currentApp);

const btApp = ref<BTInstalledApp | null>(null);
const username = ref('');
const password = ref('');
const mobileVirtualNumber = ref('');
const actionInProgress = ref(false);

const validations = {
  username: { required },
  password: { required },
  mobileVirtualNumber: { required, maxLength: maxLength(15), numeric },
};

const $v = useVuelidate(validations, { username, password, mobileVirtualNumber });

onBeforeMount(() => {
  if (currentApp.value.isInstalled) {
    btApi
      .getInstalledApp(currentWorkspace.value.id)
      .then((fetched) => {
        btApp.value = fetched;

        if (fetched) {
          username.value = fetched.username;
          password.value = fetched.password;
          mobileVirtualNumber.value = fetched.mobileVirtualNumber;
        }
      })
      .catch((err) => {
        // if it's not found, then we haven't installed the bt app fully, so let them fill in the form
        if (err.status !== 404) {
          // show error state...
        }
      })
      .finally(() => {
        emit('loaded');
      });
  } else {
    emit('loaded');
  }
});

function copyToClipboard(text: string) {
  copy(text);
  Toast.showInfo('Copied to clipboard');
}

function save() {
  if (actionInProgress.value) {
    return;
  }

  actionInProgress.value = true;

  const request = {
    installId: currentApp.value.installedAppId,
    workspaceId: currentWorkspace.value.id,
    username: username.value,
    password: password.value,
    mobileVirtualNumber: mobileVirtualNumber.value,
  } as InstallBTRequest;

  btApi
    .install(request)
    .then(() => emit('configSaved'))
    .catch((err) => Toast.showError(err.message))
    .finally(() => (actionInProgress.value = false));
}

function cancel() {
  router.push({ name: 'apps' });
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createElementBlock("fieldset", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "Webhook URL", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              disabled: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((webhookUrl) = $event))
            }, null, 512), [
              [_vModelText, webhookUrl]
            ])
          ]),
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("button", {
              class: "button is-info",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard(webhookUrl)))
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_font_awesome_icon, { icon: "copy" })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Username", -1)),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["input", { 'is-danger': _unref($v).username.$invalid && _unref($v).username.$dirty }]),
          type: "text",
          placeholder: "Enter username here",
          required: "",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((username).value = $event)),
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref($v).username.$touch()))
        }, null, 34), [
          [
            _vModelText,
            username.value,
            void 0,
            { trim: true }
          ]
        ]),
        (_unref($v).username.$invalid && _unref($v).username.$dirty)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, "The username is required"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Password", -1)),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["input", { 'is-danger': _unref($v).password.$invalid && _unref($v).password.$dirty }]),
          type: "password",
          placeholder: "Enter password here",
          required: "",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((password).value = $event)),
          onInput: _cache[5] || (_cache[5] = ($event: any) => (_unref($v).password.$touch()))
        }, null, 34), [
          [
            _vModelText,
            password.value,
            void 0,
            { trim: true }
          ]
        ]),
        (_unref($v).password.$invalid && _unref($v).password.$dirty)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, "The password is required"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "Mobile Virtual Number (MVN)", -1)),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["input", { 'is-danger': _unref($v).mobileVirtualNumber.$invalid && _unref($v).mobileVirtualNumber.$dirty }]),
          type: "text",
          placeholder: "Enter MVN here",
          required: "",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((mobileVirtualNumber).value = $event)),
          onInput: _cache[7] || (_cache[7] = ($event: any) => (_unref($v).mobileVirtualNumber.$touch()))
        }, null, 34), [
          [
            _vModelText,
            mobileVirtualNumber.value,
            void 0,
            { trim: true }
          ]
        ]),
        (_unref($v).mobileVirtualNumber.$invalid && !_unref($v).mobileVirtualNumber.required && _unref($v).mobileVirtualNumber.$dirty)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, " The MVN is required "))
          : _createCommentVNode("", true),
        (_unref($v).mobileVirtualNumber.$invalid && _unref($v).mobileVirtualNumber.required && _unref($v).mobileVirtualNumber.$dirty)
          ? (_openBlock(), _createElementBlock("p", _hoisted_16, " The MVN must be numeric and a maximum of 15 digits long "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_n_button_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_n_button, {
          variant: "primary",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (save())),
          disabled: _unref($v).$invalid,
          loading: actionInProgress.value
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("Submit")
          ])),
          _: 1
        }, 8, ["disabled", "loading"]),
        _createVNode(_component_n_button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (cancel())),
          variant: "primary--outline"
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode("Cancel")
          ])),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})